module.exports = __webpack_public_path__ + "img/ayaana.738690cd.jpg";